import $ from 'jquery';

function changeActive() {
    $(".form").toggleClass("expanded");
  }  

  const now = new Date();
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const today = days[now.getDay()];
  
  function printCoupon() {
      if(typeof window !== 'undefined'){
          window.print();
      }
    }
  

